import type { AssetReference } from '../systems/AssetLoader';
import evidencesData from '../data/evidences.json';
import type { EvidenceDefinition } from './types';

export const EVIDENCE_DEFINITIONS = (evidencesData as { evidences: EvidenceDefinition[] })
  .evidences;

export function findEvidenceDefinition(evidenceId: string): EvidenceDefinition | null {
  return EVIDENCE_DEFINITIONS.find((evidence) => evidence.id === evidenceId) ?? null;
}

export function createEvidenceImageReference(evidence: EvidenceDefinition): AssetReference {
  return {
    id: evidence.imageId ?? evidence.id,
    kind: 'evidence',
    path: evidence.imageAssetPath
  };
}
